/* eslint-disable no-template-curly-in-string */
import { type components } from 'api/playerPayback/api'
import { date, number, object, string, boolean, array } from 'yup'

export type TypeOfMessage = components['schemas']['CampaignType']
export type ExcludeType = 'LE' | 'Org' | 'CA' | 'PatronsWithCheckins' | 'None'
export type GenderType = 'Both' | 'Female' | 'Male' | 'PreferNotToAnswer'

export const LicensedEstablishmentSchema = object().shape({
  campaignId: number().required(),
  licensedEstablishmentId: number().required(),
})

export const EditCommunicationFiltersSchema = object().shape({
  typeOfMessage: string<TypeOfMessage>(),
  subjectLine: string(),
  messageContent: string(),
  linkLabel: string(),
  linkUrl: string(),
  scheduledDate: date(),
  licensedEstablishments: array().of(LicensedEstablishmentSchema),
  contestId: number(),
  excludeType: string<ExcludeType>(),
  excludedId: number(),
  corporateAccountId: number(),
  tierId: number(),
  filterGender: string<GenderType>().default('Both'),
  filterAgeRange: string().max(5, 'Age Range can be at most ${max} characters'),
  filterState: string()
    .notRequired()
    .max(200, 'State can be at most ${max} characters'),
  filterZipCode: string().max(500, 'Zip Code can be at most ${max} characters'),
  filterWinnersOnly: boolean(),
  filterIncompleteProfiles: boolean(),
  filterAccountCreatedDate: date().notRequired(),
  filterNotCheckedInSinceDate: date().notRequired(),
})
